<template>
  <ODialog ref="dialog" :maxWidth="800" hide-when-loading>
    <v-card v-if="row != null">
      <ODialogBar :title="title" @close="$refs.dialog.$dismiss()" />

      <v-tabs v-model="activeTab">
        <v-tab :value="0">Geral</v-tab>
        <v-tab :value="1">Veículo</v-tab>
        <v-tab :value="2">Billing</v-tab>
        <v-tab :value="3">Transmissão</v-tab>
        <v-tab :value="4">Problemas</v-tab>
      </v-tabs>

      <v-window v-model="activeTab">
        <v-window-item :value="0">
          <div class="maxh-5">
            <div class="h-row-wrap pa-3 children-pa-3">
              <div class="oderon-col-4 cap-cont">
                <label>Módulo</label>
                <p v-if="row.client && row.client.id">
                  <router-link :to="`/clients/${row.client.id}`">
                    {{ row.client.id }}
                  </router-link>
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Veículo</label>
                <p v-if="row.vehicle">
                  #{{ row.vehicle.idInOrg }} ─ {{ row.vehicle.code }}
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Organização</label>
                <p>{{ (row.client && row.client.org.label) || '─' }}</p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Firmware</label>
                <p>
                  <code v-if="row.client && row.client.fwVersion"
                    >0x{{ row.client.fwVersion.toString(16) }}</code
                  >
                  <span v-else>─</span>
                </p>
              </div>

              <div class="oderon-col-4 cap-cont">
                <label>Operadora</label>
                <p v-if="row.client && row.client.simCard">
                  {{ row.client.simCard.operator || '─' }}
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>ICCID</label>
                <p v-if="row.client && row.client.simCard">
                  {{ row.client.simCard.iccid || '─' }}
                </p>
                <p v-else>─</p>
              </div>

              <div class="oderon-col-4 cap-cont">
                <label>Lote</label>
                <p v-if="row.client">
                  {{ row.client.batchNumber }}
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-8 cap-cont">
                <label>Estoque</label>
                <p v-if="row.client && row.client.currentDepot">
                  {{ row.client.currentDepot.name }}
                </p>
                <p v-else>─</p>
              </div>

              <div class="oderon-col-6">
                <OCapCont label="Último checklist">
                  <div
                    v-if="
                      row.client != null && row.client.lastChecklist != null
                    "
                  >
                    {{ row.client.lastChecklist.at | moment('DD/MMM/YYYY') }}
                    por
                    <code>{{ row.client.lastChecklist.by }}</code>
                  </div>
                  <div v-else>─</div>
                </OCapCont>
              </div>

              <div class="oderon-col-6">
                <OCapCont label="Último ticket">
                  <LastTicket :value="row.client && row.client.lastTicket"/>
                </OCapCont>
              </div>

              <div class="oderon-col-12 cap-cont">
                <label>Status</label>
                <p>
                  <span class="tag" :class="statusStyle(row.status)">{{row.status}}</span>
                </p>
              </div>

              <div class="oderon-col-12 cap-cont">
                <label>Observações</label>
                <p>{{ (row.client && row.client.comments) || '─' }}</p>
              </div>
            </div>
          </div>
        </v-window-item>

        <v-window-item :value="1">
          <div class="maxh-4">
            <div class="h-row-wrap pa-3 children-pa-3">
              <div class="oderon-col-4 cap-cont">
                <label>ID na org</label>
                <p v-if="row.vehicle">
                  {{ row.vehicle.idInOrg || '─' }}
                  ({{ row.vehicle.id }})
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Organização</label>
                <p v-if="row.vehicle">
                  {{ row.vehicle.org.name || '─' }}
                </p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Grupo</label>
                <p v-if="row.vehicle">
                  {{ row.vehicle.group || '─' }}
                </p>
              </div>
              <div class="oderon-col-4 cap-cont">
                <label>Marca/Modelo</label>
                <p v-if="row.vehicle && row.vehicle.brandModel">
                  {{ row.vehicle.brandModel.name }}
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-8 cap-cont">
                <label>Tags</label>
                <OTagList v-if="row.vehicle" :value="row.vehicle.tags" />
                <p v-else>─</p>
              </div>
            </div>
          </div>
        </v-window-item>

        <v-window-item :value="2">
          <div class="maxh-4">
            <div class="h-row-wrap pa-3 children-pa-3">
              <div class="oderon-col-12 cap-cont">
                <label>Centro de Custo (do módulo)</label>
                <p v-if="row.client && row.client.costCenter">
                  {{ row.client.costCenter.name }}
                </p>
                <p v-else>─</p>
              </div>
              <div class="oderon-col-12 cap-cont">
                <label>Cliente (do veículo)</label>
                <p v-if="row.vehicle && row.vehicle.customer">
                  {{ row.vehicle.customer.label }}
                </p>
                <p v-else>─</p>
              </div>
            </div>
          </div>
        </v-window-item>

        <v-window-item :value="3">
          <div class="mah-4">
            <ODataTable :spec="txSpec" :items="allTxs" @rowClicked="goHb" />
          </div>
        </v-window-item>

        <v-window-item :value="4">
          <div class="mah-4">
            <ODataTable :spec="problemsSpec" :items="allProblems" />
          </div>
        </v-window-item>
      </v-window>

      <v-card-actions class="pa-6">
        <v-spacer />
        <v-btn text large @click="$refs.dialog.$dismiss()">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </ODialog>
</template>

<script>
import LastTicket from '@/components/LastTicket.vue'
import { InstalledBase } from '@/models'
import moment from 'moment'

const txSpec = [
  { t: 'Objeto', d: 'obj' },
  { t: 'Tipo', d: 'type' },
  { t: 'HB', d: 'heartbeatId' },
  { t: 'Data', d: 'receivedOn', f: x => moment(x).format() },
  { t: 'Delta', d: row => moment(row.receivedOn).fromNow() }
]

const problemsSpec = [
  { t: 'Objeto', d: 'obj' },
  { t: 'Tipo', d: 'type' },
  { t: 'Observações', d: 'comments' }
]

function withObj(obj, list) {
  if (list == null) return []
  return list.map(x => {
    return { obj, ...x }
  })
}

export default {
  components: {
    LastTicket,
    ODataTable: require('oderon-vue/cpts/ODataTable').default
  },
  data() {
    return this.reset()
  },
  computed: {
    title() {
      if (this.row == null) return ''
      let { vehicle, client } = this.row
      if (vehicle && client) return `${client.id} ─ ${vehicle.code}`
      if (vehicle) return vehicle.code
      return client.id
    },
    allTxs() {
      let c = withObj('Módulo', this.row.client && this.row.client.lastHbs)
      let v = withObj('Veículo', this.row.vehicle && this.row.vehicle.lastHbs)
      return c.concat(v)
    },
    allProblems() {
      let c = withObj('Módulo', this.row.client && this.row.client.problems)
      let v = withObj('Veículo', this.row.vehicle && this.row.vehicle.problems)
      return c.concat(v)
    }
  },
  methods: {
    reset() {
      return {
        activeTab: 0,
        row: null,
        id: null,
        txSpec,
        problemsSpec
      }
    },
    open(id) {
      Object.assign(this, this.reset())
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      this.row = await InstalledBase.findById(this.id)
    },

    goHb(row, index, evt) {
      let url = `/heartbeats/${row.heartbeatId}`
      if (evt && (evt.ctrlKey || evt.button == 1)) {
        window.open(`/#${url}`, '_blank')
      } else {
        this.$router.push(url)
      }
    },

    statusStyle(s) {
      if ( s == 'ProblemaAberto') return 'red'
      if ( s == 'ProblemaTratativa') return 'orange'
      if ( s == 'ChecklistVencido') return 'purple'
      if ( s == 'ChecklistNecessario') return 'yellow'
      return null
    }
  }
}
</script>

<style></style>
